<template>
  <LayoutContainer :props="props">
    <div class="kaer-image-double">
      <kaer-image
        v-for="(img, index) in props.list"
        :key="index"
        :src="img.src"
        :url="img.url"
        :index="index"
        :componentId="componentId"
        :clickTrackId="clickTrackId"
      />
    </div>
  </LayoutContainer>
</template>

<script>
import KaerImage from '../image/index.vue';

export default {
  name: 'kaer-image-dobule',
  components: {
    KaerImage
  },
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({
        list: []
      })
    }
  },
  data() {
    return {
      trackId: 'TMS-moudle-image2',
      clickTrackId: 'TMS-click-moudle-image2'
    };
  },
  mounted() {
    this.uploadData(this.trackId, 'event', { list: this.props.list, kaerComponentId: this.componentId });
  }
};
</script>

<style lang="scss" scoped>
.kaer-image-double {
  display: flex;
  width: 100%;
  padding: 4px 12px;
  justify-content: space-between;
  .kaer-image {
    width: 173px;
  }
}
</style>
